import React, { useEffect, useState } from 'react';
import { type SystemStatusView } from '../../api/types.js';
import { fetchSystemStatus } from '../../api/index.js';
import { useTranslation } from '../../i18n/useTranslation.js';

function SystemStatusTab() {
  const { t } = useTranslation();
  const [data, setData] = useState<SystemStatusView | null>(null);

  useEffect(() => {
    fetchSystemStatus()
      .then(setData)
      .catch((err) => console.error('Failed to load system status:', err));
  }, []);

  return (
    <div className="sp on">
      <div className="sp-title">{t('systemStatus.title')}</div>
      <div className="sp-subtitle">{t('systemStatus.subtitle')}</div>

      <div className="sg">
        <div className="sg-title">{t('systemStatus.coreServices')}</div>
        {data === null && <div className="status-meta">{t('systemStatus.loading')}</div>}
        {data?.core.map((s) => (
          <div key={s.id} className="status-row">
            <span className={`status-light ${s.status}`} />
            <span className="status-name">{s.name}</span>
            <span className="status-meta">{s.meta}</span>
            <span className={`status-badge2 ${s.status}`}>{s.status.toUpperCase()}</span>
          </div>
        ))}
      </div>

      <div className="sg">
        <div className="sg-title">{t('systemStatus.infrastructure')}</div>
        {data?.infra.map((s) => (
          <div key={s.id} className="status-row">
            <span className={`status-light ${s.status}`} />
            <span className="status-name">{s.name}</span>
            <span className="status-meta">{s.meta}</span>
            <span className={`status-badge2 ${s.status}`}>{s.status.toUpperCase()}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SystemStatusTab;
